import { Injectable } from '@angular/core';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogService extends AbstractRestService {
  postInit(): void { }
  
  getLog(site: string, proficy_env: string, object_id: string):Observable<GenericLambdaReturn<any>> 
  {
    let params:any={};

    params.Site = site;
    params.ProficyEnv = proficy_env;
    params.ObjectID = object_id;
        
    return this.get({
      ApiResource: "/log",
      data: params,
      repeatCall: false
    });
  }
}
